import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Breadcrumbs, Button, Typography, Link, Stack, Box } from '@mui/material';

export interface PageProps {
    heading: React.ReactNode,
    errorComponent?: React.ReactNode,
    children?: React.ReactNode[],
    backButton?: boolean,
    breadcrumbs?: boolean
    sidePanel?: React.ReactNode
}

export const Page = ({heading, errorComponent, children, backButton, breadcrumbs, sidePanel}: PageProps) => {
    const navigate = useNavigate();
    const [expandState, setExpandState] = React.useState(true); //true = expanded

    const backButtonHandler = () => navigate(-1);
    const expandCollapseToggleHandler = () => setExpandState(!expandState);

    const visibleElement = {visibility: "visible"};
    const hiddenElement = {visibility: "hidden"};

    return <>
        <Stack direction="row" spacing={5}>
            <Button onClick={backButtonHandler} sx={backButton?visibleElement:hiddenElement}>back</Button>

            {/*Breadcrumbs
            <Breadcrumbs separator=">" sx={breadcrumbs?visibleElement:hiddenElement}>
                <Link href="/Administration">Workshop specific Administration</Link>
                <Link href="">OPC Interoperability Workshop 2023</Link>
            </Breadcrumbs>*/}
        </Stack>
        
        <Stack direction="row" marginTop="10px" gap={10}>
            <Stack direction="row" minWidth={expandState?"35%":"max-content"} display={(sidePanel?"flex":"none")}  marginTop="5" marginRight="5" minHeight={"calc(100vh - 200px)"}>
                <Box sx={{flexGrow: 1, display: (expandState?undefined:"none")}}>
                    {sidePanel}
                </Box>
                <Button variant="outlined" sx={{color: "text.primary", backgroundColor: "action.selected", maxWidth: "10px", minWidth: "10px", }} onClick = {expandCollapseToggleHandler}>
                    {(expandState?"<":">")}
                </Button>
            </Stack>
            <Stack sx={{flexGrow: 1, width: '65%'}}>
                {(typeof heading === 'string') ? <Typography variant="h4">{heading}</Typography> : heading }
                {errorComponent}
                {children}
            </Stack>
        </Stack>
    </>
}